export default "__VITE_ASSET__zbUFHEyo__"